export default {
  faqList: [],
  faqCount: 0,
}